import { render, staticRenderFns } from "./PatientsFormOpinions.vue?vue&type=template&id=07e0b87c&"
import script from "./PatientsFormOpinions.vue?vue&type=script&lang=js&"
export * from "./PatientsFormOpinions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports